import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { Input, Table, Spin, Divider } from "antd";
import millify from "millify";
import { getFixedIncome } from "../api/ProductMasterAPI";

const FixedIncome = () => {
  const [filtered, setFiltered] = useState([]);

  const fixedIncome = useQuery({
    queryKey: ["fixedIncome"],
    queryFn: getFixedIncome,
    refetchOnWindowFocus: false,
    staleTime: 6 * 60 * 60 * 1000,
  });

  useEffect(() => {
    setFiltered(fixedIncome?.data);
  }, [fixedIncome.data]);

  const dataSource = filtered;
  const columns = [
    {
      title: "Symbol",
      dataIndex: "Symbol",
      align: "center",
    },
    {
      title: "Company",
      dataIndex: "CompanyName",
      align: "left",
      responsive: ["lg"],
    },
    {
      title: "ISIN",
      dataIndex: "ISIN",
      align: "center",
      responsive: ["lg"],
    },
    {
      title: "CUSIP",
      dataIndex: "CUSIP",
      align: "center",
      responsive: ["xl"],
    },
    {
      title: "Status",
      dataIndex: "Status",
      align: "center",
      responsive: ["xl"],
    },
    {
      title: "Frequency",
      dataIndex: "CouponFrequency",
      align: "center",
      responsive: ["lg"],
    },
    {
      title: "Rate",
      dataIndex: "CouponRate",
      align: "center",
      sorter: (a, b) => a.CouponRate - b.CouponRate,
    },
    {
      title: "Next Date",
      dataIndex: "NextCouponDate",
      align: "center",
      responsive: ["xl"],
    },
    {
      title: "Par",
      dataIndex: "ParValue",
      align: "center",
    },
    {
      title: "Accu Interest",
      dataIndex: "AccruedInterest",
      align: "center",
      sorter: (a, b) => a.AccruedInterest - b.AccruedInterest,
    },
    {
      title: "SPRating",
      dataIndex: "SPRating",
      align: "center",
    },
  ];

  const onSearch = (value) => {
    let upVar = value.toUpperCase();
    setFiltered(
      fixedIncome.data.filter(
        (x) => x.symbol.includes(upVar) || x.ISIN.includes(upVar) || x.CompanyName.includes(upVar)
      )
    );
  };

  return (
    <div>
      {fixedIncome.isLoading ? (
        <div className="loader">
          <Spin tip="Loading..." size="large" />
        </div>
      ) : (
        <div>
          <Input.Search
            placeholder="input search data"
            allowClear
            enterButton="Search"
            size="middle"
            // disabled={!fractional?.data}
            onSearch={onSearch}
          />
          <Divider />
          <Table
            rowKey="ISIN"
            dataSource={dataSource}
            columns={columns}
            size="small"
            // pagination={false}
            pagination={{
              position: ["bottomRight"],
              defaultPageSize: 20,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default FixedIncome;
